/** Shared markdown parsing; the package selects a browser- or server-safe sanitizer. */
import { marked } from 'marked'

import { sanitizeMarkdown, sanitizeText } from '#markdown-sanitizer'

marked.setOptions({ breaks: true, gfm: true })

export function renderMarkdown(input: string): string {
  if (!input) {
    return ''
  }
  return sanitizeMarkdown(marked.parse(input, { async: false }) as string)
}

/** Plain single-line previews, with the same parser and security policy as chat messages. */
export function stripMarkdown(input: string): string {
  if (!input) {
    return ''
  }
  return sanitizeText(marked.parse(input, { async: false }) as string)
    .replace(/\s+/g, ' ')
    .trim()
}
